export const materialPreviewHistoryLabels = {
  en: {
    open: 'View recent checks', loading: 'Loading recent checks…',
    note: 'Your latest 10 recorded checks for this material and definition. History does not confirm current readiness. An unresolved run may still be running or may have lost its outcome record; it is never replayed automatically.',
    empty: 'No recorded checks found. Missing history does not prove that a check failed.',
    failed: 'History unavailable. Verify current access and try again.',
    completed: 'Completed check recorded', failed_run: 'Failed check recorded',
    cancelled: 'Cancellation recorded', timed_out: 'Timeout recorded', unresolved: 'Outcome unresolved',
    revision: 'Recorded extraction revision: {{revision}}',
  },
  fr: {
    open: 'Voir les vérifications récentes', loading: 'Chargement des vérifications…',
    note: 'Vos 10 dernières vérifications enregistrées pour ce document et cette définition. Cet historique ne confirme pas son état actuel. Un résultat indéterminé peut correspondre à une opération en cours ou non enregistrée ; aucune relance automatique.',
    empty: 'Aucune vérification enregistrée. Un historique absent ne prouve pas un échec.',
    failed: 'Historique indisponible. Vérifiez vos droits et réessayez.',
    completed: 'Vérification terminée enregistrée', failed_run: 'Échec enregistré',
    cancelled: 'Annulation enregistrée', timed_out: 'Délai dépassé enregistré', unresolved: 'Résultat indéterminé',
    revision: 'Révision d’extraction enregistrée : {{revision}}',
  },
  hu: {
    open: 'Legutóbbi ellenőrzések', loading: 'Ellenőrzések betöltése…',
    note: 'A tananyag és a definíció legutóbbi 10 rögzített saját ellenőrzése. Az előzmények nem igazolják a jelenlegi állapotot. A tisztázatlan futás még folyamatban lehet, vagy hiányozhat az eredménye; nincs automatikus újrafuttatás.',
    empty: 'Nincs rögzített ellenőrzés. A hiányzó előzmény nem bizonyít sikertelenséget.',
    failed: 'Az előzmények nem érhetők el. Ellenőrizze jogosultságait, majd próbálja újra.',
    completed: 'Befejezett ellenőrzés rögzítve', failed_run: 'Sikertelen ellenőrzés rögzítve',
    cancelled: 'Megszakítás rögzítve', timed_out: 'Időtúllépés rögzítve', unresolved: 'Tisztázatlan eredmény',
    revision: 'Rögzített kinyerési verzió: {{revision}}',
  },
  ru: {
    open: 'Последние проверки', loading: 'Загрузка проверок…',
    note: 'Ваши последние 10 записанных проверок этого материала и определения. История не подтверждает текущее состояние. Неопределённый запуск может ещё выполняться или не иметь записи результата; автоматического повтора нет.',
    empty: 'Записанных проверок нет. Отсутствие истории не доказывает сбой.',
    failed: 'История недоступна. Проверьте права доступа и повторите попытку.',
    completed: 'Завершение проверки записано', failed_run: 'Сбой проверки записан',
    cancelled: 'Отмена записана', timed_out: 'Тайм-аут записан', unresolved: 'Результат не определён',
    revision: 'Записанная версия извлечения: {{revision}}',
  },
  de: {
    open: 'Letzte Prüfungen anzeigen', loading: 'Prüfungen werden geladen…',
    note: 'Ihre letzten 10 gespeicherten Prüfungen dieses Materials und dieser Definition. Der Verlauf bestätigt nicht den aktuellen Zustand. Ein ungeklärter Lauf kann noch laufen oder ohne Ergebnisaufzeichnung sein; keine automatische Wiederholung.',
    empty: 'Keine gespeicherten Prüfungen. Ein fehlender Verlauf beweist keinen Fehler.',
    failed: 'Verlauf nicht verfügbar. Prüfen Sie Ihre Zugriffsrechte und versuchen Sie es erneut.',
    completed: 'Abgeschlossene Prüfung gespeichert', failed_run: 'Fehlgeschlagene Prüfung gespeichert',
    cancelled: 'Abbruch gespeichert', timed_out: 'Zeitüberschreitung gespeichert', unresolved: 'Ergebnis ungeklärt',
    revision: 'Gespeicherte Extraktionsversion: {{revision}}',
  },
};
